import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideStatusDone = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkStatusDoneRidesProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRideStatusDone,
    entity,
  );
  const bulkStatusDoneRidesProcess = useRecoilValue(
    activeProcessSF(bulkStatusDoneRidesProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRideStatusDone,
      toastSummaryOnComplete: true,
      process: bulkStatusDoneRidesProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [bulkStatusDoneRidesProcess, entity, onComplete, stopProcessPolling, t]);
};
